import React, { useRef } from 'react';
import ApportionmentsHeader from '../ApportionmentsHeader';
export const PaymentsToClinicalTrialsHeader = _ref => {
  let {
    claim,
    setHeaderScrollPosition,
    isShowInvolvement,
    allProjects
  } = _ref;
  const reportsHeaderRef = useRef(null);
  const onHeaderScroll = e => {
    setHeaderScrollPosition(e.target.scrollLeft);
  };
  const ReportSubheader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex"
    }, allProjects.map((report, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "bg-primary text-white border-start border-end cost_categories_subpage_header_cell_container"
      }, report.project_name || 'Unnamed Project');
    })), /*#__PURE__*/React.createElement("div", {
      className: "d-flex"
    }, /*#__PURE__*/React.createElement(ApportionmentsHeader, {
      claim: claim,
      isShowInvolvement: isShowInvolvement,
      allProjects: allProjects
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Total Amount"), claim.claim_group.project_methodology === 'project_basis' ? /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement("div", {
    ref: reportsHeaderRef,
    onScroll: onHeaderScroll,
    className: "cost_categories_subpage_header"
  }, /*#__PURE__*/React.createElement(ReportSubheader, null))) : null, isShowInvolvement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", null, "Direct R&D %"), /*#__PURE__*/React.createElement("th", null, "Indirect R&D %")), /*#__PURE__*/React.createElement("th", null, "R&D %"), /*#__PURE__*/React.createElement("th", null, "R&D Amount")));
};